module.exports = __webpack_public_path__ + "static/media/Gym2.658575fd.webp";